<template>
  <a class="navbar-item" @click="LogIntoSis" v-if="!isLearner">
    Log into SIS
    <genexMiniLoader v-if="loading" class="ml-2"/>
  </a>
</template>

<script>
import User from "@/models/lms/User";
import genexMiniLoader from "@/components/global/genexMiniLoader.vue";
import {mapState} from "vuex";

export default {
  name: "LoginToSIS",
  components: {genexMiniLoader},
  data() {
    return {
      loading: false
    }
  },
  methods: {
    LogIntoSis() {
      this.loading = true
      if (this.$store.state.auth.user.id !== undefined && this.$store.state.auth.user.id !== null) {
        User.LoginIntoSIS(this.$store.state.auth.user.id).then((response) => {
          this.loading = false
          if (response.response.data) {
            const auth = response.response.data;
            window.open(
                process.env.VUE_APP_TENANT_FRONTEND_URL +
                "login" +
                "?supportLoginTenantId=" +
                auth.sis_tenant_id +
                "&supportLoginToken=" +
                auth.access_token +
                "&supportLoginEmail=" +
                this.$store.state.auth.user.email +
                "&supportLoginUuid=" +
                auth.uuid,
                "_blank"
            );
          }
        }).catch(
            err => {
              this.loading = false
              this.handleError(err)
            }
        )
      }
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLearner() {
      return this.user.roles.some(role => role.attributes.name === "learner");
    }
  }
}
</script>

<style scoped lang="scss">

</style>
